import './App.css';
import Navbar from './navbar/navbar';
import { Routes, Route } from 'react-router-dom';
import About from './About/about';
import Contact from './Contact/contact';
import Footer from './Footer/footer';
import Home from './Home/home';
import Features from './Features/features';
import Terms from './Terms/terms';
import ChildSafety from './ChildSafety/child-safety';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <div className="mainContent">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/features" element={<Features />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/child-safety" element={<ChildSafety />} />
        </Routes>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
